import { createContext, ReactNode, useContext, useState } from "react";

// Define available tab types as a union type
// export type TabType = "fast-food" | "liquor";
export type TabType = "fast-food";

// Define the context state interface
interface TabContextState {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
}

// Define the provider props
interface TabContextProviderProps {
  children: ReactNode;
}

// Create context with default values
const TabContext = createContext<TabContextState>({
  activeTab: "fast-food",
  setActiveTab: () => {},
});

// Custom hook for using the tab context
export const useTabContext = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error("useTabContext must be used within a TabContextProvider");
  }
  return context;
};

// Constants for tab types
export const TAB_TYPES = {
  FOOD: "fast-food" as TabType,
  // BEVERAGES: "liquor" as TabType,
} as const;

export function TabContextProvider({ children }: TabContextProviderProps) {
  const [activeTab, setActiveTab] = useState<TabType>(TAB_TYPES.FOOD);

  const value = {
    activeTab,
    setActiveTab,
  };

  return (
    <TabContext.Provider value={value}>
      {children}
    </TabContext.Provider>
  );
}
